(function() {
	document.addEventListener("DOMContentLoaded", function() {

		if(document.getElementById("alerts")) {
			var cont = document.getElementById("leftFilterSection");
			var form = cont.getElementsByTagName("form")[0];
			var brand = form.querySelector("select[name=brand]");
			var model = form.querySelector("select[name=model]");

			model.style.display = "none";

			brand.addEventListener("change", function() {
				
				if(this.value) {
					model.style.display = "block";
				} else {
					model.style.display = "none";
				}
			});

			// years select
			/*var rangeBlock = document.getElementById("yRange");
			var year1 = rangeBlock.querySelector("select[name=year1]");
			var year2 = rangeBlock.querySelector("select[name=year2]");

			year1.addEventListener("change", function() {
				var y = this.value;
				
				for(var i = 0; i < year2.children.length; i++) {
					if(year2.children[i].value < y) {
						year2.removeChild(year2.children[i]);
						year2.children[i] = null;
						i--;
					}
				}
			});

			year2.addEventListener("change", function() {
				var y = this.value;
				
				for(var i = 0; i < year1.children.length; i++) {
					if((year1.children[i].value > y) || (!year1.children[i].value)) {
						year1.removeChild(year1.children[i]);
						year1.children[i] = null;
						i--;
					}
				}
			});*/
		}

	});
})();